module.exports = __webpack_public_path__ + "static/media/campaign-default-image-800x450.5d0f4d51.png";